module.exports = __webpack_public_path__ + "media/images/icons/icon_triangle_arrow_bottom_primary-d11c4f123f194b5640871341bfa63700.svg";